import './index.scss';

import { Component } from 'react';

import { BraxUncontrolledTextField, BraxUncontrolledTextFieldProps } from '../BraxUncontrolledTextField';
import { BraxIcon } from '../../BraxIcon';

export type BraxUncontrolledPasswordFieldProps = Omit<BraxUncontrolledTextFieldProps, 'type' | 'mask' | 'placeholder'>;

type BraxUncontrolledPasswordFieldState = {
    show: boolean
};

export class BraxUncontrolledPasswordField extends Component<BraxUncontrolledPasswordFieldProps, BraxUncontrolledPasswordFieldState> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    state = {
        show: false
    };

    hideClass = 'webkitTextSecurity' in document.body.style ? 'hide-value-with-text-security' : 'hide-value-with-custom-font';

    toggle() {
        this.setState(prevState => ({
            show: !prevState.show
        }));
    }

    render() {
        return (
            <div className={`brax-password-field ${this.props.autoComplete === 'off' && !this.state.show ? this.hideClass : ''}`}>
                <BraxUncontrolledTextField
                    type={this.props.autoComplete === 'off' || this.state.show ? 'text' : 'password'}
                    placeholder="········"
                    {...this.props}
                />

                <BraxIcon icon={this.state.show ? 'eye-slashed' : 'eye'} onClick={() => this.toggle()} />
            </div>
        );
    }

}
